import React from "react";

import { ToastContainer } from "react-toastify";
import source1 from "../../assets/images/Frame.png";
import source2 from "../../assets/images/H2OLogo.png";
const AuthLayout = ({ children }) => {
  return (
    <section className="flex h-screen w-screen justify-center items-center relative overflow-hidden">
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        draggable
        pauseOnHover
        limit={1}
        theme="light"
      />
      {/* right side */}
      <section className="w-full lg:w-1/2 flex justify-center items-center">
        {children}
      </section>
    </section>
  );
};

export default AuthLayout;
